import dayjs from 'dayjs';

import { fetchServerDate } from '@/api/internal';
import { TimestampNumber } from '@/types/common';

export const generateTimeStamp = async (): Promise<TimestampNumber> => {
  try {
    const date = await fetchServerDate();
    return dayjs(date).valueOf();
  } catch {
    return 0;
  }
};
